import { type ReactNode } from "react";
import { Flex } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";

/**
 * Wraps the onboarding cell's actions so a click on them is skipped by the grid row-click handler
 * (which opens the settings drawer), via the `[data-suppress-row-click]` marker.
 */
export const OnboardingMenuSlot = ({ children }: { children: ReactNode }) => (
  <Flex alignItems="center" gap={Sizes.SM} data-suppress-row-click>
    {children}
  </Flex>
);
